import { Routes } from '@angular/router';
import { DashboardRoutes } from './views/dashboard/dashboard.routing';
import { AuthGuard } from '../../../abraj-shared/src/lib/guards/auth.guard';

export const routes: Routes = [
    {
            path:'',loadComponent:()=> import('./views/dashboard/dashboard.component').then(m => m.DashboardComponent ),children: DashboardRoutes,canActivate: [],
        }  
];
